import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import equipmentConstants from "./../Constants/EquipmentConstants";

class EquipmentGroupActions {
  deleteEquipment(anlageid, status, deleteChildOption) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/UpdateAnlage?id=" +
        anlageid +
        "&status=" +
        status +
        "&deleteChildOption=" +
        deleteChildOption,
      "POST",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.DELETE_EQUIPMENT_SUCCESS,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.DELETE_EQUIPMENT_FAILURE,
          });
        }
      }
    );
  }

  copyEquipment(anlageid, anzahl, userid) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/CopyAnlage?id=" +
        anlageid +
        "&count=" +
        anzahl +
        "&userid=" +
        userid,
      "POST",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.COPY_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.COPY_EQUIPMENT_FAILURE,
          });
        }
      }
    );
  }

  GetEquipmentForm(anlagegruppeId) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/NewEquipmentForm?anlagegruppeid=" +
        anlagegruppeId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENTFORM_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENTFORM_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  CreateEquipment(equipment) {
    httpRequest(
      config.webServiceURL + "/Anlage/InsertAnlage",
      "PUT",
      JSON.stringify(equipment),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.INSERT_NEWEQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.INSERT_NEWEQUIPMENT_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  GetAnlageDetails(anlageid) {
    httpRequest(
      config.webServiceURL + "/Anlage/GetAnlage?id=" + anlageid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENTDETAILS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENTDETAILS_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  UpdateEquipment(equipment) {
    httpRequest(
      config.webServiceURL + "/Anlage/SaveOrUpdateAttribute",
      "PUT",
      JSON.stringify(equipment),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.UPDATE_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.UPDATE_EQUIPMENT_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  UpdateEquipmentStatus(anlageid, status, userid) {
    httpRequest(
      config.webServiceURL +
        "/Anlage/UpdateAnlage?id=" +
        anlageid +
        "&status=" +
        status +
        "&userid=" +
        userid,
      "POST",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  SaveUpdateEquipmentPicture(imageData) {
    httpRequest(
      config.webServiceURL + "/Document/SaveUpdateEquipmentPicture",
      "POST",
      JSON.stringify(imageData),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.SAVE_EQUIPMENT_IMAGES_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.SAVE_EQUIPMENT_IMAGES_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  setDefaultEquipmentImage(id) {
    httpRequest(
      config.webServiceURL + "/Document/SetDefualtEquipmentImage/" + id,
      "PUT",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  ScrapEquipment(data) {
    httpRequest(
      config.webServiceURL + "/Anlage/ScrapAnlage",
      "POST",
      JSON.stringify(data),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.SCRAP_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.SCRAP_EQUIPMENT_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getEquipmentScrapPhotos(anlageId) {
    httpRequest(
      config.webServiceURL + "/document/EquipmentScrapPhotos/" + anlageId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentConstants.GET_EQUIPMENT_SCRAP_IMAGES_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new EquipmentGroupActions();
